import { FormControl } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as DatePickerType } from '@/schemas/sceneDataSchema';
import { Controller, UseFormReturn } from 'react-hook-form';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const formatObfuscated = (dob: string): string => {
  const [year, month, day] = dob.split('-');
  return `${month}/${day}/${year}`;
};

export const DatePickerFormElement = ({ form, component }: { form: UseFormReturn; component: DatePickerType }) => {
  const obfuscatedDob = component.value?.includes('*') ? formatObfuscated(component.value ?? '') : undefined;

  const labelText = obfuscatedDob ?? component.label;

  return (
    <Controller
      control={form.control}
      name={encodeFieldKey(component)}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          fullWidth
          error={!!error}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={labelText}
              defaultValue={component.value && !component.value.includes('*') ? new Date(component.value) : undefined}
              onChange={(value) => {
                if ((value instanceof Date && !isNaN(value.getTime())) || value === null) {
                  const date = value?.toISOString() ?? null;
                  field.onChange(date);
                }
              }}
              slotProps={{
                field: { clearable: true },
                textField: {
                  error: !!error,
                  helperText: error?.message,
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      )}
    />
  );
};
